module.exports = __webpack_public_path__ + "img/audience-delete.efe3c655.svg";